import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { signatureFactory } from "../signature-factory";
import type {
    _OrderEventBaseFactoryParams} from "./_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "./_order-base.event";

const orderPendingConfirmationEventZodSchema = _orderEventBaseZodObject.merge(
    z.object({
        type: z.literal("PENDING_CONFIRMATION"),
        createdBy: userIdZodSchema.or(z.string()),
        estimatedDeliveryTime: isoAndUnixZodSchema.optional(),
    }),
);
type OrderPendingConfirmationEvent = z.infer<
    typeof orderPendingConfirmationEventZodSchema
>;

type FactoryParams = _OrderEventBaseFactoryParams &
    Except<
        OrderPendingConfirmationEvent,
        "type" | "_id" | "_type" | "_createdAt" | "signature"
    >;

type Params = Except<FactoryParams, "signature">;

const orderPendingConfirmationEventFactory = (
    params: Params,
): OrderPendingConfirmationEvent => ({
    ..._orderEventBaseFactory({
        orderId: params.orderId,
        orderGroupId: params.orderGroupId,
        _version: params._version,
        providerId: params.providerId,
        providerSlug: params.providerSlug,
        signature: signatureFactory(params.orderId, "PENDING_CONFIRMATION"),
    }),

    type: "PENDING_CONFIRMATION",
    createdBy: params.createdBy,
    estimatedDeliveryTime: params.estimatedDeliveryTime,
});

export {
    orderPendingConfirmationEventFactory,
    orderPendingConfirmationEventZodSchema,
};
export type { OrderPendingConfirmationEvent };
